import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Layout } from 'antd'
import Intercom from 'react-intercom'

import Sidebar from './Sidebar/index'

import Topbar from './Topbar/index'

const { Content } = Layout

export class MainApp extends Component {
    componentDidUpdate(prevProps) {
        const { appId, apiKey, showSidebar, adminEmail, adminOrganization, appProduct } = this.props

        if (
            (prevProps.apiKey !== apiKey && apiKey) ||
            (prevProps.showSidebar !== showSidebar && showSidebar && apiKey)
        ) {
            const script = document.createElement('script')

            script.id = 'ekkonowstagscript'
            script.async = true

            const ekkoFrame = document.getElementById('ekkoNowFrame')
            if (ekkoFrame) {
                ekkoFrame.parentNode.removeChild(ekkoFrame)
            }

            script.innerHTML = `
                (function (w,d,n,u) {
                    w[n]=w[n]||function(){(w[n].q=w[n].q||[]).push(arguments)};
                    var a=d.createElement("script");
                    a.type="text/javascript",a.async=1,a.src=u;
                    var b=d.getElementsByTagName("script")[0];
                    b.parentNode.insertBefore(a,b)
                })(window,document,'ekkoNow','//static.ekko.chat/now/ekkonow.min.js');
                ekkoNow('init', '${appId}', {
                    adminToken: '${apiKey}',
                    inDashboard: true,
                    user: {    
                        email: '${adminEmail}',
                        ${adminOrganization ? "username: '" + adminOrganization.replace("'", "\\\'") + "'," : ''}
                    },
                    position: 'left',
                    bottomOffset: 0,
                    welcomeText: "Speak to your community as an admin from here.",
                });
            `

            document.body.appendChild(script)
        } else if (
            (prevProps.apiKey !== apiKey && !apiKey) ||
            (prevProps.showSidebar !== showSidebar && !showSidebar)
        ) {
            const ekkoFrame = document.getElementById('ekkoNowFrame')
            if (ekkoFrame) {
                ekkoFrame.parentNode.removeChild(ekkoFrame)
            }
        }
    }

    componentWillUnmount() {
        const ekkoFrame = document.getElementById('ekkoNowFrame')
        if (ekkoFrame) {
            ekkoFrame.parentNode.removeChild(ekkoFrame)
        }
    }

    render() {
        const { children, showSidebar, adminEmail, adminId, adminOrganization } = this.props

        const userIntercom = {
            user_id: adminId,
            email: adminEmail,
            name: adminOrganization
        }

        return (
            <Layout className="gx-app-layout">
                {showSidebar && <Sidebar />}
                <Layout>
                    <Topbar showNavCollapser={showSidebar} />
                    <Content className="gx-layout-content">
                        <div className="gx-main-content-wrapper">{children}</div>
                    </Content>
                    <Intercom appID="kfksglsr" {...userIntercom} />
                </Layout>
            </Layout>
        )
    }
}

const mapStateToProps = state => ({
    appId: state.ekko.currentAppId,
    apiKey: state.ekko.currentApp.api_key,
    adminEmail: state.admin.me.email,
    adminId: state.admin.me.id,
    adminOrganization: state.admin.me.organization,
    appProduct: state.ekko.currentApp.product,
})

export default connect(
    mapStateToProps,
    null
)(MainApp)
